import {defineAsyncComponent} from 'vue';

const demoFormPopup = defineAsyncComponent(() => import('@/views/demo/DemoFormPopup.vue'));
const employeeDetail = defineAsyncComponent(() => import('@/views/poc/EmployeeDetail.vue'));

export function registerTreasury(app) {
  app.component('DemoFormPopup', demoFormPopup);
  app.component('EmployeeDetail', employeeDetail);
}
